<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名"
                ><a-input v-model="queryParam.userName" placeholder="姓名"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号"
                ><a-input v-model="queryParam.telPhone" placeholder="手机号"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="登录账号"
                  ><a-input v-model="queryParam.account" placeholder="登录账号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="I">正常</a-select-option>
                    <a-select-option value="L">锁定</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >
                <a-button
                  type="primary"
                  icon="plus"
                  class="button-margin-left"
                  @click="showModal('add')"
                  v-hasAnyPermission="`admin:add`"
                  >新建</a-button
                >
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <!-- <a-button
          type="primary"
          icon="plus"
          @click="showModal('add')"
          v-hasAnyPermission="`admin:add`"
          >新建</a-button
        > -->
        <a-dropdown v-hasAnyPermission="`admin:unlock,admin:lock,admin:delete`">
          <a-menu slot="overlay" @click="menuClick">
            <a-menu-item key="1" v-hasAnyPermission="`admin:unlock`">
              <a-icon type="unlock" />
              解锁
            </a-menu-item>
            <a-menu-item key="2" v-hasAnyPermission="`admin:lock`">
              <a-icon type="lock" />
              锁定
            </a-menu-item>
            <a-menu-item key="3" v-hasAnyPermission="`admin:delete`">
              <a-icon type="delete" />
              删除
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
        :rowSelection="options.rowSelection"
      >
        <span slot="status" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              :color="record.sta == 'I' ? '#108ee9' : 'grey'"
              >{{ record.sta == "I" ? "正常" : "锁定" }}</a-tag
            >
          </template>
        </span>
        <!-- <span slot="status" slot-scope="text"
          ><a-badge
            :status="text | statusTypeFilter"
            :text="text | statusFilter"
        /></span> -->

        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              v-hasAnyPermission="`admin:edit`"
              @click="action(record, 'edit')"
              >编辑</a
            >
            <a
              class="a-action"
              v-hasAnyPermission="`admin:reset`"
              @click="action(record, 'reset')"
              >重置密码</a
            >
            <a
              class="a-action"
              v-hasAnyPermission="`admin:allot`"
              @click="action(record, 'role')"
              >分配角色</a
            >
          </template>
        </span>
      </s-table>
    </a-card>
    <!-- 弹出框 -->
    <a-modal
      v-model="modal.visible"
      :title="modal.title"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form-model
        ref="ruleForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="登录账号" prop="account">
          <a-input v-model="formData.account" :maxLength="20" />
        </a-form-model-item>
        <a-form-model-item
          v-if="modal.type == 'add'"
          label="登录密码"
          prop="password"
        >
          <a-input
            v-model="formData.password"
            type="password"
            :maxLength="20"
          />
        </a-form-model-item>
        <a-form-model-item label="姓名" prop="userName">
          <a-input v-model="formData.userName" :maxLength="10" />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="telPhone">
          <a-input v-model="formData.telPhone" :maxLength="15" />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input v-model="formData.remark" type="textarea" :maxLength="200" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 角色分配 -->
    <a-modal
      v-model="roleModal.visible"
      :title="roleModal.title"
      @ok="roleHandleOk"
      @cancel="roleCancel"
    >
      <div>
        <span style="margin-right: 10px;">角色:</span>
        <template v-for="tag in roleModal.roles">
          <a-checkable-tag
            :key="tag.roleCode"
            :checked="roleModal.checkRoles.indexOf(tag.roleCode) > -1"
            @change="checked => handleChange(tag, checked)"
          >
            {{ tag.roleName }}
            <a-tag
              style="line-height: 1.3;padding: 0 2px;border-radius: 3px;"
              :style="{
                color: tag.level == 'SYSTEM' ? '#ff6666' : '#108ee9',
                borderColor: tag.level == 'SYSTEM' ? '#ff6666' : '#108ee9'
              }"
              color="#ffffff"
            >
              {{ tag.level == "SYSTEM" ? "系统级" : "业务级" }}
            </a-tag>
          </a-checkable-tag>
        </template>
      </div>
    </a-modal>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";

export default {
  name: "AdminList",
  components: {
    STable,
    PageView
  },
  data() {
    // handler
    let handleTelphone = (rule, value, callback) => {
      const mobileRegex = /^[1]([3-9])[0-9]{9}$/.test(value);
      if (value) {
        if (!mobileRegex) {
          callback("请输入正确手机号");
        }
      }
      callback();
    };
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "登录账号",
          dataIndex: "account",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "姓名",
          dataIndex: "userName"
        },
        {
          title: "手机号",
          dataIndex: "telPhone"
        },
        // {
        //   title: "状态",
        //   dataIndex: "sta",
        //   scopedSlots: { customRender: "status" }
        // },
        {
          title: "备注",
          dataIndex: "remark",
          ellipsis: true
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.systemBksApi
          .pageSystemUser(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      },
      selectedRowKeys: [],
      selectedRows: [],
      //表格参数配置
      options: {
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        account: "",
        password: "",
        userName: "",
        telPhone: "",
        remark: ""
      },
      //form rules
      rules: {
        account: [
          {
            required: true,
            message: "请输入登录账号",
            trigger: "change"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "change"
          }
        ],
        telPhone: [{ validator: handleTelphone }]
      },
      roleModal: {
        visible: false,
        title: "分配角色",
        userNo: "",
        checkRoles: [],
        roles: []
      }
    };
  },
  filters: {
    statusFilter(type) {
      let str = "有效";
      if (type == "L") {
        str = "锁定";
      } else if (type == "X") {
        str = "失效";
      }
      return str;
    },
    statusTypeFilter(type) {
      let str = "success";
      if (type == "L") {
        str = "default";
      } else if (type == "X") {
        str = "error";
      }
      return str;
    }
  },
  created() {},
  methods: {
    showModal(type) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加用户" : "编辑用户";
      this.modal.type = type;
    },
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.formData = Object.assign({}, record);
        this.showModal(type);
      } else if (type == "reset") {
        let param = {
          type: "reset",
          userNo: record.userNo
        };
        this.$http.systemBksApi.modifyPassword(param).then(res => {
          if (res.result == 0) {
            this.$refs.table.refresh(true);
            this.$message.success(res.msg);
          }
        });
      } else if (type == "role") {
        this.roleModal.visible = true;
        this.roleModal.userNo = record.userNo;
        this.$http.systemBksApi
          .findUserRole({ userNo: record.userNo })
          .then(res => {
            this.roleModal.checkRoles = res.resultObject.checkRoles;
            this.roleModal.roles = res.resultObject.roles;
          });
      } else if (type == "del") {
        this.$http.systemBksApi
          .removeSystemUser({ ids: record.id })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$refs.table.clearSelected();
              this.$message.success(res.msg);
            }
          });
      }
    },

    /**
     * 批量操作
     * @param {Object} evt
     */
    menuClick(evt) {
      if (this.selectedRowKeys.length > 0) {
        let param = {};
        if (evt.key == 1 || evt.key == 2) {
          param.sta = evt.key == 1 ? "I" : "L";
          param.ids = this.selectedRowKeys.join(",");
          this.$http.systemBksApi.modifySystemUserSta(param).then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$refs.table.clearSelected();
              this.$message.success(res.msg);
            }
          });
        }
        if (evt.key == 3) {
          this.$http.systemBksApi
            .removeSystemUser({ ids: this.selectedRowKeys.join(",") })
            .then(res => {
              if (res.result == 0) {
                this.$refs.table.refresh(true);
                this.$refs.table.clearSelected();
                this.$message.success(res.msg);
              }
            });
        }
      } else {
        this.$message.info("请选择数据");
      }
    },

    cancel() {
      this.formData = {};
      this.$refs.ruleForm.resetFields();
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          let action = "";
          if (this.modal.type == "add") {
            action = "saveSystemUser";
          } else {
            action = "modifySystemUser";
          }
          this.$http.systemBksApi[action](param).then(res => {
            if (res.result == 0) {
              this.modal.visible = false;
              this.cancel();
              this.$message.success(res.msg);
              this.$refs.table.refresh(true);
            }
          });
        }
      });
    },
    roleCancel() {
      this.roleModal.visible = false;
      this.roleModal.checkRoles = [];
      this.roleModal.userNo = "";
      this.roleModal.roles = [];
    },
    /**
     * 保存
     */
    roleHandleOk() {
      this.$http.systemBksApi
        .saveUserRole({
          userNo: this.roleModal.userNo,
          roleCodes: this.roleModal.checkRoles.join(",")
        })
        .then(res => {
          this.$message.success(res.msg);
          this.roleCancel();
        });
    },
    handleChange(tag, checked) {
      let tags;
      if (checked) {
        tags = [...this.roleModal.checkRoles, tag.roleCode];
      } else {
        tags = this.roleModal.checkRoles.filter(t => t != tag.roleCode);
      }
      this.roleModal.checkRoles = tags;
    },
    /**
     * 选中table数据
     * @param {Object} selectedRowKeys
     * @param {Object} selectedRows
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    }
  }
};
</script>
